import { render, staticRenderFns } from "./PersonalDocumentsCreateFormSidebar.vue?vue&type=template&id=2fb37744&scoped=true"
import script from "./PersonalDocumentsCreateFormSidebar.vue?vue&type=script&lang=js"
export * from "./PersonalDocumentsCreateFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb37744",
  null
  
)

export default component.exports